import React from 'react';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import InputField from '../../../../components/InputField/InputField';

type Props = {
    filter: any;
    setFilter: (filter: any) => void;
    onSearch: () => void;
};

const UserFilter = ({ filter, setFilter, onSearch }: Props) => {
    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Nombre"
                        value={filter.first_name || ''}
                        onChange={(value) => setFilter({ ...filter, first_name: value })}
                        placeholder="Ingrese el nombre"
                        size="small"
                    />
                </div>
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Apellido Paterno"
                        value={filter.last_name || ''}
                        onChange={(value) => setFilter({ ...filter, last_name: value })}
                        placeholder="Ingrese el apellido paterno"
                        size="small"
                    />
                </div>
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Apellido Materno"
                        value={filter.second_last_name || ''}
                        onChange={(value) => setFilter({ ...filter, second_last_name: value })}
                        placeholder="Ingrese el apellido materno"
                        size="small"
                    />
                </div>

                <div className='col-md-auto'>
                    <div>
                        <ButtonGeneral
                            onClick={onSearch}
                            title="Buscar"
                            variant="outline"
                            size="small"
                            icon="fa-search"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserFilter;
